import QuinielazoService from "@/services/QuinielazoService";


export const namespaced = true;

export const state = {
	quinielas_publicas: [],
	mis_quinielas:[],
	quiniela: {}
};

export const mutations = {
	SET_QUINIELAS_PUBLICAS(state, quinielas) {
		state.quinielas_publicas = quinielas;
	},
    ADD_QUINIELAS_PUBLICAS(state, quiniela){
    	state.quinielas_publicas.unshift(quiniela)
    },
	SET_QUINIELA(state, quiniela){
		state.quiniela = quiniela;
	},
    UPDATE_QUINIELAS(state, quiniela){
    	//update quinielas_publicas
    	
    	//Si es quiniela amigos y no es privada
    	if (quiniela.tipo == 1 && quiniela.privada == 0 ) {
    		
    		//Si la quiniela ya esta en juego y es vs amigos
    		if (quiniela.estado > 0) {
    			//quitar de esta lista
    			state.quinielas_publicas = state.quinielas_publicas.filter(q => q.id != quiniela.id)
    		}else{ //Si no
    			//Actualizar en la lista de publicas
		    	for (var qp in state.quinielas_publicas) {
		    		if (state.quinielas_publicas[qp].id == quiniela.id) {
		    			this._vm.$set(state.quinielas_publicas,qp,quiniela)
		    			break;
		    		}
		    	}
    		}
    	}

    	//update mis quinielas
    	for (var q in state.mis_quinielas) {
    		if (state.mis_quinielas[q].id == quiniela.id) {
    			this._vm.$set(state.mis_quinielas, q, quiniela)
    			break;
    		}
    	}

    	//Si es la quiniela que se esta viendo
    	if (state.quiniela.id == quiniela.id) {
    		state.quiniela = quiniela
    	}
    },
    SET_MIS_QUINIELAS(state, quinielas){
    	state.mis_quinielas = quinielas
    },
    ADD_MIS_QUINIELAS(state, quiniela){
    	state.mis_quinielas.unshift(quiniela)
    },
    PUSH_MIS_QUINIELAS(state, quinielas){
    	state.mis_quinielas.push(...quinielas)	
	},
	REMOVE_SOLICITUD(state, solicitud){
		state.quiniela.solicitudes = state.quiniela.solicitudes.filter(s => s.id != solicitud.id)
	},
	ADD_SOLICITUD(state, solicitud){
		if (state.quiniela.id == solicitud.quiniela_id) {
			state.quiniela.solicitudes.push(solicitud)
		}
	}
};

export const actions = {
	fetchQuinielasPublicas({ commit }) {
		QuinielazoService.getQuinielasPublicas()
		.then(resp => {
			commit("SET_QUINIELAS_PUBLICAS", resp.data);
		})
		.catch(err => {
			console.log(err);
		});
	},
	fetchQuiniela({commit, dispatch}, quiniela){
		/*var q = getters.getQuinielaById(quiniela.id);

		if (q) {
			commit("SET_QUINIELA", q);
			console.log('already found')
			return true
		} else {*/
			return QuinielazoService.getQuiniela(quiniela.id)
			.then(resp => {
				commit("SET_QUINIELA", resp.data)
				return true
			})
			.catch(err => {
				dispatch("notification/add",{
					type: "error",
					message: "Hubo un error al cargar la quiniela " + quiniela.id
				},{ root: true });

				return err
			});
		//}
	},
	saveQuiniela({commit, dispatch}, quiniela){
		if (quiniela.id != null) {
			//Si esta actualizando la quiniela, es porque se esta uniendo un jugador
			return QuinielazoService.updateQuiniela(quiniela)
			.then(resp => {
				if (!quiniela.privada) {
					commit('ADD_MIS_QUINIELAS', resp.data)
				}
				commit('SET_QUINIELA', resp.data)
				commit('user/RESTAR_PUNTOS', resp.data.apuesta, { root: true })
				let msg = quiniela.privada ? 'Se envio tu solicitud' : 'Te uniste a la quiniela' + quiniela.nombre
				dispatch("notification/add",{
					type: "success",
					message: msg,
					icon: 'check'
				}, {root: true});

				return resp
			})
			.catch(err => {
				let error = (err.response.data.message != undefined) ? err.response.data.message : err.message
				dispatch("notification/add",{
					type: "error",
					message: "Hubo un error al guardar la quiniela: " + error
				},{ root: true });
			})
		}else{
			//Nueva quiniela
			return QuinielazoService.postQuiniela(quiniela)
			.then(resp => {
				commit('ADD_MIS_QUINIELAS', resp.data);
				//Si es quiniela amigos y publica
				if (quiniela.tipo == 1 && quiniela.privada == 0) {
					//Agregarla a las publicas
					dispatch('addPublica',resp.data)
				}
				commit('user/RESTAR_PUNTOS', resp.data.apuesta, { root: true })
				dispatch("notification/add",{
					type: "success",
					message: "Se guardo tu quiniela " + resp.data.nombre,
					icon: 'check'
				}, {root: true});

				return resp
			})
			.catch(err => {
				let error = (err.response.data.message != undefined) ? err.response.data.message : err.message
				dispatch("notification/add",{
					type: "error",
					message: "Hubo un error al guardar la quiniela: " + error,
					location: 'bottom'
				},{ root: true });
				console.log((err.response.data.message != undefined) ? err.response.data.message:err.message)
			})
		}
	},
	update({ commit }, quiniela){
		commit('UPDATE_QUINIELAS',quiniela);
	},
	addPublica({commit}, quiniela){
		commit('ADD_QUINIELAS_PUBLICAS',quiniela)
	},
	fetchMisQuinielas({commit, dispatch}, cant = null){
		return QuinielazoService.getMisQuinielas(cant)
		.then(resp => {
			if (cant != null) {
				commit('PUSH_MIS_QUINIELAS', resp.data)
			}else{
				commit('SET_MIS_QUINIELAS', resp.data)
			}
		})
		.catch(err => {
			dispatch("notification/add",{
				type: "error",
				message: "Hubo un error al cargar las ultimas quinielas " + err.message
			},{ root: true });	
		})
	},
	aceptarSolicitud({dispatch, commit }, solicitud){
		QuinielazoService.aceptarSolicitud(solicitud.id)
		.then(() => {
			commit('REMOVE_SOLICITUD', solicitud)
			dispatch('notification/add',{
				type: "success",
				message: "Se agrego el usuario a la quiniela"
			},{root: true})
		})
		.catch(() => {
			dispatch("notification/add", {
				type: "error",
				message: "Hubo un error al aceptar la solicitud"
			}, { root: true });	
		})
	},
	rechazarSolicitud({ dispatch, commit }, solicitud){
		QuinielazoService.rechazarSolicitud(solicitud.id)
		.then(() => {
			commit('REMOVE_SOLICITUD', solicitud)
			dispatch('notification/add', {
				type: "success",
				message: "Se rechazo la solicitud del usuario"
			}, { root: true })
		})
		.catch(() => {
			dispatch("notification/add", {
				type: "error",
				message: "Hubo un error al rechazar la solicitud"
			}, { root: true });
		})
	}
};

export const getters = {
	getQuinielaById: state => id => {
		return state.quinielas.find(quiniela => quiniela.id == id);
	}
};
